
import { defineComponent, computed } from "vue";
import gql from "graphql-tag";
import Page from "@/components/Page.vue";
import { useQuery, useResult } from "@vue/apollo-composable";
import { OAuthUsageHistoryType } from "@/graphql/types";
import AppHeader from "@/components/AppHeader.vue";
import Error from "@/components/Error.vue";

const GET_OAUTH_USAGE_HISTORY = gql`
  query oauthUsageHistory {
    oauthUsageHistory {
      connectionName
      clientId
      latestUsage
      isClientCredentialFlow
    }
  }
`;

export default defineComponent({
  name: "Forbindelsesoversigt",
  components: {
    AppHeader,
    Error,
    Page,
  },
  setup() {
    const { result, loading, error } = useQuery(GET_OAUTH_USAGE_HISTORY, null, {
      fetchPolicy: "network-only",
    });

    const history = computed<OAuthUsageHistoryType[]>(
      () =>
        useResult(result, [], (data) => data.oauthUsageHistory ?? [])
          .value as OAuthUsageHistoryType[]
    );

    return {
      history,
      loading,
      error,
    };
  },
});
